import { useI18n } from "@/i18n";
import { SectionShell } from "@/components/section-shell";

// Raporlar grubu: İstatistikler · Satışlar · İşlem Geçmişi
// Hepsi "geçmişte ne oldu?" sorusunun farklı kesitleri:
//  - Analytics: menü görüntülenme + tıklama
//  - Sales: gerçek sipariş + ciro
//  - Logs: audit trail / sistem olayları
export function ReportsSection() {
  const { t } = useI18n();
  return (
    <SectionShell
      tabs={[
        { to: ".", label: t("analytics"), end: true },
        { to: "sales", label: t("sales") },
        { to: "logs", label: t("activity_log") },
      ]}
    />
  );
}
